import { ISlotViewItem } from 'modules/SlotsRoot/types/interfaces/Slots/Slots'
import { ISoftwissResponse, ISoftwissServerGame } from 'modules/SlotsRoot/types/interfaces/Slots/Softwiss'
import { getSoftswissSlotImage } from 'modules/SlotsRoot/utils/images'

import { IConvertGameList, ISlotConverter } from '../../types/converter'
import { excludeSoftwissGameIds, excludeSoftwissProviders, getTab, getTabLive } from './SoftwissUtils'

class SoftwissConverter implements ISlotConverter {
  convertGameList = ({ data, platform }: { data: ISoftwissServerGame[]; platform?: string }): ISlotViewItem[] =>
    data
      .map((item: ISoftwissServerGame) => ({
        id: item.identifier,
        gameId: item.identifier,
        description: item.title,
        gameName: item.title,
        tab: getTab(item.identifier, item.title),
        tabLive: getTabLive(item.identifier),
        provider: item.producer,
        hasDemoMode: true,
        imageUrl: getSoftswissSlotImage(item.provider, item.identifier, platform),
        routeProvider: 'softwiss',
      }))
      // .filter(item => excludePgramaticList.indexOf(item.gameId) === -1)
      .filter(item => excludeSoftwissGameIds.indexOf(item.gameId) === -1)
      .filter(item => excludeSoftwissProviders.indexOf(item.provider.toLowerCase()) === -1)

  convertGameUrl = ({ data }: any) => data.launch_options.game_url
}

export default SoftwissConverter
